import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.2, 0.7, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", once = true, ...rest }) => {
  const reduce = useReducedMotion();
  const M = motion[as] || motion.div;
  return (
    <M
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.6, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const Stagger = ({ children, className = "", gap = 0.08, ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : "hidden"}
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const Item = ({ children, className = "", y = 24, ...rest }) => (
  <motion.div className={className} variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } } }} {...rest}>
    {children}
  </motion.div>
);

export const Marquee = ({ items, className = "" }) => (
  <div className={`overflow-hidden ${className}`} aria-hidden="true">
    <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center gap-10 text-sm font-semibold uppercase tracking-[0.18em]">
          {t}<span className="h-1.5 w-1.5 rounded-full bg-brass" />
        </span>
      ))}
    </div>
  </div>
);
